import {
  dateTime as dateTimeBase,
  money as moneyBase,
  relative as relativeBase,
} from '@wyocspay/ui';
import { localeForCountry } from './locale.js';

/**
 * Formatting bound to the merchant's own conventions.
 *
 * The locale lives in a module variable rather than in React context, and that
 * is a deliberate trade. Context would be tidier, but every table cell and
 * badge in the panel already imports these three functions directly; threading
 * a hook through all of them would touch a hundred call sites to change one
 * behaviour, and each of those is a chance to miss one and leave a date in the
 * wrong convention.
 *
 * It is safe here because the panel serves exactly one merchant per session -
 * there is never a second locale in flight. `setLocaleCountry` is called once
 * when the session resolves, before anything renders a date.
 */

let locale = 'en-GB';

export function setLocaleCountry(country: string | null | undefined): void {
  locale = localeForCountry(country);
}

export function currentLocale(): string {
  return locale;
}

export function dateTime(iso: string | null): string {
  return dateTimeBase(iso, locale);
}

export function relative(iso: string | null): string {
  return relativeBase(iso, locale);
}

export function money(amount: number, currency: string): string {
  return moneyBase(amount, currency, locale);
}

/** Long form, for anything a person files or forwards. */
export function dateLong(iso: string | null): string {
  if (!iso) return '-';
  return new Date(iso).toLocaleDateString(locale, { dateStyle: 'long' });
}
